import React from "react";
import {
  find as _find,
  get as _get,
  uniq as _uniq,
  values as _values,
  set as _set,
  pick as _pick,
} from "lodash";
import NumberFormat from "react-number-format";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { SnackbarActionTypes } from "../../redux/snackbar/snackbar.types";
import { Input, Typography, Tab, Button, Box } from "@material-ui/core";

import StyledTabs from "../StyledTabs/StyledTabs.component";

import rh from "../../images/rh.png";
import rbm from "../../images/rbm.png";
import bma from "../../images/bma.png";
import bma24 from "../../images/bma247.png";
import hag from "../../images/hag.png";
import giroflex from "../../images/giroflex.png";
import offecct from "../../images/offecct.png";

import useStyles from "./CompanyRelatedDetails.style";

import UserSelectionInput from "../UserSelectionInput/UserSelectionInput.component";
import CompanyAddress from "../CompanyAddress/CompanyAddress.component";
import CompanySubsidiaries from "../CompanySubsidiaries/CompanySubsidiaries.component";
import CompanyContracts from "../CompanyContracts/CompanyContracts.component";
import {
  retrieveCompanyAddresses,
  retrieveCompanyAppendices,
} from "../../redux/company/company.actions";
import {
  updateCompanyBrand,
  disableCompanyBrand,
} from "../../helpers/services/CompanyServices";
import { useTranslation } from "react-i18next";

const getBrandLogo = (brandName) => {
  switch (brandName) {
    case "rh":
      return rh;
    case "rbm":
      return rbm;
    case "bma":
      return bma;
    case "bma24":
      return bma24;
    case "hag":
      return hag;
    case "giroflex":
      return giroflex;
    case "offecct":
      return offecct;
    default:
      return null;
  }
};
//all brands
let allBrands = [
  {
    id: 1,
    name: "rh",
  },
  {
    id: 2,
    name: "rbm",
  },
  {
    id: 4,
    name: "hag",
  },
  {
    id: 3,
    name: "giroflex",
  },
  {
    id: 5,
    name: "bma24",
  },
  {
    id: 6,
    name: "bma",
  },
  {
    id: 7,
    name: "offecct",
  },
];

const CompanyRelatedDetails = (props) => {
  console.log("where");
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state) => state.company);

  const classes = useStyles();
  let associatedBrands = selectedCompany.brands
    ? selectedCompany.brands.map((v) => v.brand_name)
    : [];

  let displayBrandsList = _uniq([
    ...associatedBrands,
    ...allBrands.map((b) => b.name),
  ]);
  console.log("Display List");
  console.log(displayBrandsList);
  const [tabValue, setTabValue] = React.useState(
    "subsidiaries"
    //_get(displayBrandsList, "0") || "subsidiaries"
  );
  console.log("selectedCompany", selectedCompany);
  const [selectedBrandAppendix, setSelectedBrandAppendix] = React.useState({});
  const [addresses, setAddresses] = React.useState(
    selectedCompany.addresses || []
  );
  const [subsidiaries, setSubsidiaries] = React.useState(
    selectedCompany.subsidiaries || []
  );
  const [contracts, setContracts] = React.useState([]);
  const user = useSelector((state) => state.user);

  const handleTabChange = (event, newValue) => {
    console.log("TabValue-->", newValue);
    if (displayBrandsList.includes(newValue)) {
      setSelectedBrandAppendix({
        company_id: selectedCompany.id,
        brand_id: _get(_find(allBrands, { name: newValue }), "id"),
        ...(_find(selectedCompany.appendices, { name: newValue }) || {}),
      });
    }
    setTabValue(newValue);
  };
  const handleBackButton = () => {
    history.push("/companies");
  };

  React.useEffect(() => {
    dispatch(retrieveCompanyAppendices(selectedCompany.contract_id));
    // dispatch(retrieveCompanySubsidiaries(selectedCompany.id));
  }, []);

  let SubsidiaryAddress = [];
  React.useEffect(() => {
    handleTabChange({}, tabValue);
    setAddresses(selectedCompany.addresses || []);
    selectedCompany.subsidiaries &&
      selectedCompany.subsidiaries.length > 0 &&
      selectedCompany.subsidiaries.map((subsidiary, i) => {
        subsidiary["addresses"].map((s) => {
          SubsidiaryAddress.push({
            id: s.id,
            street: s.street,
            house_no: s.house_no,
            zip_code: s.zip_code,
            city: s.city,
            country: s.country,
            parent_company_id: selectedCompany.id,
            subsidiary_id: subsidiary.id,
            name: subsidiary.name,
            customer_no: subsidiary.customer_no,
            register_no: subsidiary.register_no,
            vat_id: subsidiary.vat_id,
          });
        });
      });
    setSubsidiaries(SubsidiaryAddress || []);
    let _contracts = [];
    _contracts.push({
      contract_id: selectedCompany.contract_id,
      contract_status: selectedCompany.status,
      ..._pick(selectedCompany, [
        "main_sales_lead_email",
        "main_sales_lead_first_name",
        "main_sales_lead_last_name",
        "main_sales_lead_id",
        "contract_year",
      ]),
    });
    setContracts(_contracts);
  }, [selectedCompany]);
  const handleNewAddressAdded = () => {
    retrieveCompanyAddresses();
  };
  console.log("subsidiaries", subsidiaries);
  return (
    <div>
      {selectedCompany.id && (
        <React.Fragment>
          <div className={classes.sectionSeparator} />
          <div className={classes.navigationPanel}>
            <StyledTabs
              className={classes.tabPanel}
              indicatorColor="primary"
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="on"
            >
              <Tab
                className={classes.tab}
                label="Tochterfirmen"
                color="secondary"
                wrapped
                value="subsidiaries"
              />
              <Tab
                className={classes.textTab}
                label="Adressen"
                color="primary"
                textColor="primary"
                wrapped
                value="addresses"
              />
              {selectedCompany.addresses &&
                selectedCompany.addresses.length > 0 && (
                  <Tab
                    className={classes.textTab}
                    label="Vertrags"
                    color="primary"
                    textColor="primary"
                    wrapped
                    value="contracts"
                  />
                )}
              {selectedCompany.addresses &&
                selectedCompany.addresses.length > 0 &&
                displayBrandsList.map((brandName) => (
                  <Tab
                    key={brandName}
                    className={classes.tab}
                    icon={
                      <img
                        src={getBrandLogo(brandName)}
                        className={classes.tabLogos}
                      />
                    }
                    value={brandName}
                  />
                ))}
            </StyledTabs>

            <div>
              <Button className={classes.button} onClick={handleBackButton}>
                {"< "}
                {t("flokk_contract.back_to_list")}
              </Button>
            </div>
          </div>
          <TabPanel value={tabValue} indices={["subsidiaries"]}>
            <CompanySubsidiaries
              companyId={selectedCompany.id}
              subsidiaries={subsidiaries}
            />
          </TabPanel>
          <TabPanel value={tabValue} indices={["addresses"]}>
            <CompanyAddress
              companyId={selectedCompany.id}
              addresses={addresses}
              onNewAddressAdded={handleNewAddressAdded}
            />
          </TabPanel>
          <TabPanel value={tabValue} indices={["contracts"]}>
            <CompanyContracts
              companyId={selectedCompany.id}
              contracts={contracts}
            />
          </TabPanel>
          <TabPanel
            value={tabValue}
            indices={displayBrandsList.map((brand) => {
              return brand;
            })}
          >
            <div className={classes.brandContainer}>
              <BrandDetails brand={selectedBrandAppendix} />
            </div>
          </TabPanel>
        </React.Fragment>
      )}
    </div>
  );
};

const BrandDetails = function ({ brand }) {
  const { selectedCompany } = useSelector((state) => state.company);
  const classes = useStyles();
  const [brandDetails, setBrandDetails] = React.useState(brand || {});
  const [validationResult, setValidationResult] = React.useState({});
  const dispatch = useDispatch();
  React.useEffect(() => {
    setBrandDetails(brand);
    console.log("Rendering Brand Details", brand);
  }, [brand]);
  const handleSalesLeadChange = (value) => {
    console.log("HandleSalesLeadChange", value);
    let _brandDetails = { ...brandDetails };
    if (value) {
      _brandDetails.sales_lead_first_name = value.first_name;
      _brandDetails.sales_lead_last_name = value.last_name;
      _brandDetails.sales_lead_id = value.id;
    } else {
      _brandDetails.sales_lead_first_name = "";
      _brandDetails.sales_lead_last_name = "";
      _brandDetails.sales_lead_id = "";
    }
    console.log("Setting Brand Details", _brandDetails);
    setBrandDetails(_brandDetails);
  };
  const handleTeamLeadChange = (value) => {
    let _brandDetails = { ...brandDetails };
    if (value) {
      _brandDetails.team_lead_first_name = value.first_name;
      _brandDetails.team_lead_last_name = value.last_name;
      _brandDetails.team_lead_id = value.id;
    } else {
      _brandDetails.team_lead_first_name = "";
      _brandDetails.team_lead_last_name = "";
      _brandDetails.team_lead_id = "";
    }
    console.log("Setting Brand Details", _brandDetails);
    setBrandDetails(_brandDetails);
  };

  const handleRevenueChange = (year, v) => {
    console.log(year, v);
    brandDetails.revenues = brandDetails.revenues.map((r) => {
      if (r.year === year) r.actual = Number(v.value);
      return r;
    });
    setBrandDetails(brandDetails);
  };

  const validateData = async () => {
    let errorElementIdentifiers = {};
    brandDetails.revenues.map((r) => {
      if (!r.actual) r.actual = 0;
      // if (r.year < new Date().getFullYear()) {
      //   _set(errorElementIdentifiers, "revenue_" + r.year, ["erforderlich"]);
      // }
    });
    if (!brandDetails.sales_lead_id)
      _set(errorElementIdentifiers, "sales_lead", ["Bitte GvL auswählen"]);
    if (!brandDetails.team_lead_id)
      _set(errorElementIdentifiers, "team_lead", ["Bitte RL auswählen"]);

    setValidationResult(errorElementIdentifiers);
    console.log(errorElementIdentifiers, {} === errorElementIdentifiers);
    if (Object.keys(errorElementIdentifiers).length > 0) return false;
    else return true;
  };

  const handleSubmit = async () => {
    let validationResult = await validateData();
    if (validationResult) {
      console.log(brandDetails);
      await updateCompanyBrand(brandDetails);
      dispatch(retrieveCompanyAppendices(selectedCompany.contract_id));
      dispatch({
        type: SnackbarActionTypes.SHOW_SNACKBAR,
        payload: { message: "Gespeichert" },
      });
    }
  };

  const handleEnableBrand = async () => {
    let _brandDetails = { ...brandDetails };
    _brandDetails.name = _get(
      _find(allBrands, { id: brandDetails.brand_id }),
      "name"
    );
    _brandDetails.sales_lead_first_name = "";
    _brandDetails.sales_lead_last_name = "";
    _brandDetails.team_lead_first_name = "";
    _brandDetails.team_lead_last_name = "";
    _brandDetails.revenues = [
      {
        year: 2017,
        actual: 0,
        ...(_pick(brandDetails, ["company_id", "brand_id"]) || {}),
      },
      {
        year: 2018,
        actual: 0,
        ...(_pick(brandDetails, ["company_id", "brand_id"]) || {}),
      },
      {
        year: 2019,
        actual: 0,
        ...(_pick(brandDetails, ["company_id", "brand_id"]) || {}),
      },
      {
        year: 2020,
        actual: 0,
        ...(_pick(brandDetails, ["company_id", "brand_id"]) || {}),
      },
    ];
    setBrandDetails(_brandDetails);
  };

  const handleDisableBrand = async () => {
    await disableCompanyBrand(brandDetails);
    dispatch(retrieveCompanyAppendices(selectedCompany.contract_id));

    let _brandDetails = _pick(brandDetails, ["company_id", "brand_id"]);
    setBrandDetails(_brandDetails);
    dispatch({
      type: SnackbarActionTypes.SHOW_SNACKBAR,
      payload: { message: "Gespeichert" },
    });
  };
  return (
    <React.Fragment>
      {brandDetails && brandDetails.name && (
        <React.Fragment>
          <div className={classes.brandSection}>
            <div className={classes.brandPeopleSection}>
              <div className={classes.formSectionTitle}>Ansprechpartner</div>
              <div className={classes.text_container}>
                <div className={classes.text_container_label}>GVL :</div>
                <UserSelectionInput
                  onValueChange={handleSalesLeadChange}
                  defaultValue={{
                    first_name: brandDetails.sales_lead_first_name,
                    last_name: brandDetails.sales_lead_last_name,
                  }}
                />
              </div>
              {validationResult["sales_lead"] && (
                <div className={classes.inlineErrorMessage}>
                  {validationResult["sales_lead"]}
                  <br />
                </div>
              )}
              <div className={classes.text_container}>
                <div className={classes.text_container_label}>RL :</div>
                <UserSelectionInput
                  onValueChange={handleTeamLeadChange}
                  defaultValue={{
                    first_name: brandDetails.team_lead_first_name,
                    last_name: brandDetails.team_lead_last_name,
                  }}
                />
              </div>
              {validationResult["team_lead"] && (
                <div className={classes.inlineErrorMessage}>
                  {validationResult["team_lead"]}
                  <br />
                </div>
              )}
            </div>

            <div className={classes.brandRevenues}>
              <div className={classes.formSectionTitle}>Umsatzhistorie</div>
              {brandDetails.revenues &&
                brandDetails.revenues.map((r) => {
                  if (Number(r.year) < new Date().getFullYear()) {
                    return (
                      <React.Fragment key={"revenue_" + r.year}>
                        <div className={classes.text_container}>
                          <div className={classes.text_container_label}>
                            {r.year} :{" "}
                          </div>
                          <div
                            className={classes.spanText}
                            style={{ color: "#4a5568" }}
                          >
                            <NumberFormat
                              className={classes.inputRevenue}
                              value={
                                _get(
                                  _find(brandDetails.revenues, {
                                    year: r.year,
                                  }),
                                  "actual"
                                ) || 0
                              }
                              customInput={Input}
                              inputMode="numeric"
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              decimalScale={0}
                              suffix={" €"}
                              onValueChange={(values) => {
                                handleRevenueChange(r.year, values);
                              }}
                            />
                          </div>
                        </div>
                        {validationResult["revenue_" + r.year] && (
                          <div className={classes.inlineErrorMessage}>
                            {validationResult["revenue_" + r.year]}
                            <br />
                          </div>
                        )}
                      </React.Fragment>
                    );
                  }
                })}
            </div>
          </div>
          <div className={classes.brandActions}>
            <Button
              type="submit"
              variant="outlined"
              color="primary"
              onClick={() => {
                handleSubmit();
              }}
            >
              Speichern
            </Button>
            <Button
              type="submit"
              variant="outlined"
              color="secondary"
              onClick={handleDisableBrand}
            >
              Deaktivieren
            </Button>
          </div>
        </React.Fragment>
      )}
      {brandDetails && !brandDetails.name && (
        <React.Fragment>
          <div className={classes.brandActions}>
            <Button
              type="submit"
              variant="outlined"
              color="primary"
              onClick={handleEnableBrand}
            >
              Aktivieren
            </Button>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
const TabPanel = function (props) {
  const { children, value, indices, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={!indices.includes(value)}
      //   id={`simple-tabpanel-${index}`}
      //   aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {indices.includes(value) && (
        <Box style={{ paddingBottom: "1rem", background: "#fff" }}>
          {children}
        </Box>
      )}
    </Typography>
  );
};

export default CompanyRelatedDetails;
